export function TermsPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-slate-900 dark:text-slate-100 mb-6">
          Terms of Service
        </h1>

        <div className="prose prose-slate dark:prose-invert max-w-none">
          <p className="text-slate-600 dark:text-slate-400 mb-4">
            Last updated: November 25, 2025
          </p>
          <p className="text-slate-600 dark:text-slate-400 mb-8">
            Privacy Forum is operated by <strong>maxint.dev</strong>. These Terms of Service govern your use of our platform.
          </p>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Acceptance of Terms
            </h2>
            <p className="text-slate-700 dark:text-slate-300">
              By accessing and using Privacy Forum, you accept and agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our platform.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              User Accounts
            </h2>
            <div className="space-y-4 text-slate-700 dark:text-slate-300">
              <p>When creating an account, you agree to:</p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>Provide accurate information</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>Maintain the security of your account credentials</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>Not share your account with others</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>Notify us immediately of any unauthorized access</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Acceptable Use
            </h2>
            <div className="space-y-4 text-slate-700 dark:text-slate-300">
              <p>You agree NOT to:</p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-red-600 dark:text-red-400 mr-2">✕</span>
                  <span>Post illegal, harmful, or offensive content</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 dark:text-red-400 mr-2">✕</span>
                  <span>Harass, threaten, or abuse other users</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 dark:text-red-400 mr-2">✕</span>
                  <span>Spam or post unsolicited advertisements</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 dark:text-red-400 mr-2">✕</span>
                  <span>Attempt to hack, exploit, or disrupt the platform</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 dark:text-red-400 mr-2">✕</span>
                  <span>Violate others' privacy or intellectual property rights</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 dark:text-red-400 mr-2">✕</span>
                  <span>Create multiple accounts to evade bans or restrictions</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Marketplace Terms
            </h2>
            <div className="space-y-4 text-slate-700 dark:text-slate-300">
              <p>When using the marketplace:</p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>Sellers must accurately describe their services</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>Buyers and sellers must honor their agreements</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>We are not responsible for disputes between users</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                  <span>Payment processing fees may apply</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Content and Intellectual Property
            </h2>
            <p className="text-slate-700 dark:text-slate-300 mb-4">
              You retain ownership of content you post. By posting, you grant us a license to display, distribute,
              and moderate that content on the platform.
            </p>
            <p className="text-slate-700 dark:text-slate-300">
              Our platform code, design, and branding are protected by copyright and other intellectual property laws.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Moderation and Enforcement
            </h2>
            <p className="text-slate-700 dark:text-slate-300 mb-4">
              We reserve the right to:
            </p>
            <ul className="space-y-2 text-slate-700 dark:text-slate-300">
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Remove content that violates these terms</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Suspend or terminate accounts for violations</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Report illegal activity to authorities</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand-600 dark:text-brand-400 mr-2">•</span>
                <span>Modify or discontinue features at our discretion</span>
              </li>
            </ul>
          </div>

          <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-8">
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
              Limitation of Liability
            </h2>
            <p className="text-slate-700 dark:text-slate-300">
              Privacy Forum is provided "as is" without warranties of any kind. We are not liable for any damages
              arising from your use of the platform, including but not limited to direct, indirect, incidental,
              or consequential damages.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
